// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__24XqN","rootSmall":"AddTileButton_rootSmall__3mZmD"};